import React from 'react';
import { ResellerColoredFrame } from 'swag-client-common/components/partials/admin-as-user-widget/components/reseller-colored-frame';
import LogoutWidget from 'swag-client-common/components/partials/admin-as-user-widget/components/logout-widget';
import { AdminModeColoredFrame } from 'swag-client-common/components/partials/admin-as-user-widget/components/admin-mode-colored-frame';
import ColoredFrame from './components/colored-frame';
export const AdminWidget = ({
  isLoggedInAsResellerAdmin,
  isSwagAdminMode,
  shouldShowAdminWidget,
  logout,
  user
}) => {
  if (!shouldShowAdminWidget) {
    return null;
  }
  if (isLoggedInAsResellerAdmin) {
    return /*#__PURE__*/React.createElement(ResellerColoredFrame, null);
  }
  if (isSwagAdminMode) {
    return /*#__PURE__*/React.createElement(AdminModeColoredFrame, null);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LogoutWidget, {
    user: user,
    logout: logout
  }), /*#__PURE__*/React.createElement(ColoredFrame, {
    color: "red"
  }));
};